/* ############################################################################################################
###############################################################################################################

CACONCEPT

###############################################################################################################
############################################################################################################ */

/* ------------------------------------------------------------------------------------------------------------

product-card > supprimer de la liste quand produit exclusif revendeurs et client non-revendeur
Se gère en complément dans le fichier snippets > product-card.liquid

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {

  function cleanInvisibleProducts(root = document) {
    root.querySelectorAll('slideshow-slide, .product-grid__item')
      .forEach(el => {
        if (el.querySelector('.produit-invisible')) {
          el.remove();
        }
      });
  }

  // Run initial
  cleanInvisibleProducts();

  // Observe future injections
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          cleanInvisibleProducts(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


/* ------------------------------------------------------------------------------------------------------------

page-product > SKU dynamqiue pour Variant 
Se gère uniquement avec ce JS 
+ Bloc Liquid personnalisé sur le theme de la page produit

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {
  // Tous les wrappers SKU sur la page (fiche produit + collection)
  document.querySelectorAll('.product-sku-wrapper').forEach(wrapper => {
    const productId = wrapper.dataset.productId;
    const skuValueEl = wrapper.querySelector('.product-sku__value');
    if (!skuValueEl) return;

    // Lookup variantId => SKU
    const variants = {};
    document.querySelectorAll(`.product-variants[data-product-id="${productId}"] span[data-variant-id][data-variant-sku]`).forEach(el => {
      variants[el.dataset.variantId] = el.dataset.variantSku;
    });

    // Cibler le formulaire
    // Si wrapper est dans .product-card => collection
    // Sinon -> fiche produit
    let form = wrapper.closest('.product-card')?.querySelector('form') || 
               document.querySelector('.variant-picker__form');
    if (!form) return;

    // Fonction pour mettre à jour le SKU
    function updateSku() {
      const selectedInput = form.querySelector('input[data-variant-id]:checked') ||
                            form.querySelector('input[data-variant-id]');
      if (!selectedInput) return;

      const variantId = selectedInput.dataset.variantId;
      skuValueEl.textContent = variants[variantId] || '';
    }

    // Initial
    updateSku();

    // Observer le formulaire pour capter les changements dynamiques
    const observer = new MutationObserver(updateSku);
    observer.observe(form, { childList: true, subtree: true, attributes: true });

    // Écouter les changements d’input
    form.querySelectorAll('input[data-variant-id]').forEach(input => {
      input.addEventListener('change', updateSku);
    });
  });
});

/* ------------------------------------------------------------------------------------------------------------

product-card > SKU dynamique pour Variant 
Se gère avec ce JS 
+ Fichier snippets/product-sku.liquid 
+ Ligne de code "{% render 'product-sku', product: product %}" dans le fichier snippets/product-card.liquid

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card').forEach(card => {
    const wrapper = card.querySelector('.product-sku-wrapper');
    if (!wrapper) return;

    const skuValueEl = wrapper.querySelector('.product-sku__value');
    if (!skuValueEl) return;

    const productId = wrapper.dataset.productId;

    // Map variantId => SKU
    const variants = {};
    card.querySelectorAll(`.product-variants[data-product-id="${productId}"] span[data-variant-id][data-variant-sku]`)
      .forEach(el => {
        variants[el.dataset.variantId] = el.dataset.variantSku;
      });

    function updateSkuFromSelectedInput() {
      const selectedInput =
        card.querySelector('input[data-variant-id]:checked') ||
        card.querySelector('input[data-variant-id]');

      if (!selectedInput) return;

      const variantId = selectedInput.dataset.variantId;
      if (variantId && variants[variantId]) {
        skuValueEl.textContent = variants[variantId];
      }
    }

    // 🔑 IMPORTANT : attendre que Horizon ait fini
    requestAnimationFrame(() => {
      updateSkuFromSelectedInput();
    });

    // Swatches / radios
    card.querySelectorAll('input[data-variant-id], label[data-variant-id]').forEach(el => {
      el.addEventListener('click', () => {
        const variantId = el.dataset.variantId;
        if (variantId && variants[variantId]) {
          skuValueEl.textContent = variants[variantId];
        }
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card').forEach(card => {
    const skuWrapper = card.querySelector('.product-sku-wrapper');
    const contents = card.querySelector('.contents .text-block');

    if (!skuWrapper || !contents) return;

    // Éviter de déplacer plusieurs fois
    if (!contents.contains(skuWrapper)) {
      contents.appendChild(skuWrapper);
    }
  });
});


/* ------------------------------------------------------------------------------------------------------------

main-collection > déplacer .hero-wrapper .rte en mobile 

------------------------------------------------------------------------------------------------------------ */

const RTEManager = (() => {

  const SELECTOR_RTE = '.main-collection .hero-wrapper .rte';
  const MOBILE_BREAKPOINT = 750;

  let rte, main, originalParent, placeholder, sectionFoot = null;

  function init() {
    rte = document.querySelector(SELECTOR_RTE);
    main = document.querySelector('main');

    if (!rte || !main) return;

    originalParent = rte.parentNode;
    placeholder = document.createComment('rte-original-position');
    originalParent.insertBefore(placeholder, rte);

    move();
    window.addEventListener('resize', move);
  }

  function move() {
    if (!rte || !main) return;

    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    if (isMobile) {
      if (!sectionFoot) {
        sectionFoot = document.createElement('div');
        sectionFoot.className = 'section-foot';
      }
      if (!main.contains(sectionFoot)) {
        main.appendChild(sectionFoot);
      }
      if (rte.parentNode !== sectionFoot) {
        sectionFoot.appendChild(rte);
        rte.classList.add('rte-moved');
      }

    } else {
      if (rte.parentNode !== originalParent) {
        originalParent.insertBefore(rte, placeholder.nextSibling);
        rte.classList.remove('rte-moved');
      }
      if (sectionFoot && sectionFoot.childElementCount === 0) {
        sectionFoot.remove();
        sectionFoot = null;
      }
    }
  }

  return { init };

})();



/* ------------------------------------------------------------------------------------------------------------

main-collection > déplacer .shopify-section (liste des produits) en bas de page quand celle-ci est vide (Aucun produit trouvé) 

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {

  function moveEmptyResultsSection() {

    const mainCollection = document.querySelector('.main-collection');
    if (!mainCollection) return;

    const resultsList = mainCollection.querySelector('results-list');
    if (!resultsList) return;

    // Vérifie la présence de product-card (balise)
    const hasProductCard = resultsList.querySelector('product-card') !== null;

    if (!hasProductCard) {

      // Récupère la section Shopify parente
      const shopifySection = resultsList.closest('.shopify-section');

      if (shopifySection && shopifySection.parentElement === mainCollection) {
        mainCollection.appendChild(shopifySection);
      }
    }
  }

  moveEmptyResultsSection();

});


/* ------------------------------------------------------------------------------------------------------------

accordion >  supprimer accordion-custom si details-content est vide

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {

  function cleanAccordions() {
    const accordions = document.querySelectorAll('accordion-custom');

    accordions.forEach(accordion => {
      const content = accordion.querySelector('.details-content');
      if (!content) return;

      // Condition 1 : details-content totalement vide
      const isEmpty =
        content.children.length === 0 &&
        content.textContent.trim().length === 0;

      // Condition 2 : présence de .image-block svg
      const hasImageBlockSvg = !!content.querySelector('.image-block svg');

      if (isEmpty || hasImageBlockSvg) {

        const sectionWrapper = accordion.closest('.section-wrapper');

        // Supprimer l'accordéon
        accordion.remove();

        // Si la section-wrapper ne contient plus aucun accordion-custom → supprimer
        if (
          sectionWrapper &&
          sectionWrapper.querySelectorAll('accordion-custom').length === 0
        ) {
          sectionWrapper.remove();
        }
      }
    });
  }

  cleanAccordions();

});


/* ------------------------------------------------------------------------------------------------------------

main-page >  supprimer section-wrapper si pas txt ou pas img

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {

  function cleanSectionWrappers() {
    const wrappers = document.querySelectorAll('.main-page .section-wrapper');

    wrappers.forEach(wrapper => {

      const hasTextBlock = wrapper.querySelector('.text-block') !== null;
      const hasImage = wrapper.querySelector('img') !== null;

      /* ----------------------------------------------------------------------
         RÈGLE 1 : Si AUCUN des deux => supprimer la section complète
      ---------------------------------------------------------------------- */
      if (!hasTextBlock && !hasImage) {
        wrapper.remove();
        return; // on s’arrête ici pour éviter suite inutile
      }

      /* ----------------------------------------------------------------------
         RÈGLE 2 : Si .text-block n’existe pas => supprimer .group-block
      ---------------------------------------------------------------------- */
      if (!hasTextBlock) {
        const groupBlock = wrapper.querySelector('.group-block');
        if (groupBlock) {
          groupBlock.remove();
        }
      }

      /* ----------------------------------------------------------------------
         RÈGLE 3 : Si img n’existe pas => supprimer .image-block + max-width:none
      ---------------------------------------------------------------------- */
      if (!hasImage) {

        // Ajouter la classe solo à .group-block
        const groupBlock = wrapper.querySelector('.group-block');
        if (groupBlock) {
          groupBlock.classList.add('solo');
        }

        // Supprimer le bloc image
        const imageBlock = wrapper.querySelector('.image-block');
        if (imageBlock) {
          imageBlock.remove();
        }

        // Élément texte -> max-width:none
        const groupBlockContent = wrapper.querySelector('.group-block-content');
        if (groupBlockContent) {
          groupBlockContent.style.maxWidth = 'none';
        }
      }

    });
  }

  cleanSectionWrappers();

});


/* ------------------------------------------------------------------------------------------------------------

main-page >  supprimer section collection si pas img

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {

  function cleanResourceList() {
    const resourceSections = document.querySelectorAll('.main-page .section-resource-list');

    resourceSections.forEach(section => {
      const hasImage = section.querySelector('img') !== null;

      if (!hasImage) {
        section.remove();
      }
    });
  }

  cleanResourceList();

});


/* ------------------------------------------------------------------------------------------------------------

section > supprimer si vide 

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section');
  sections.forEach(section => {
    if (!section.textContent.trim()) { // vérifie si le texte est vide
      section.remove(); // supprime la section vide
    }
  });
});

/* ------------------------------------------------------------------------------------------------------------

menu > supprimer les slot="overflow" 

------------------------------------------------------------------------------------------------------------ */

/*
window.addEventListener('load', () => {

  const SELECTOR = '.header .menu-list__list-item[slot="overflow"]';

  function cleanOverflowSlots() {
    document.querySelectorAll(SELECTOR).forEach(item => {
      item.removeAttribute('slot');
    });
  }

  // Exécution immédiate
  cleanOverflowSlots();

  // MutationObserver ultra robuste
  const observer = new MutationObserver(mutations => {
    let shouldClean = false;

    mutations.forEach(mutation => {
      // Si un nouveau node est ajouté
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            // Si le node correspond directement
            if (node.matches && node.matches(SELECTOR)) {
              shouldClean = true;
            }
            // Si des enfants correspondent
            if (node.querySelector && node.querySelector(SELECTOR)) {
              shouldClean = true;
            }
          }
        });
      }
    });

    if (shouldClean) {
      cleanOverflowSlots();
    }
  });

  // Observe tout le body
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
*/


/* ------------------------------------------------------------------------------------------------------------

menu__item > ajouter la class au lien de la page courante

------------------------------------------------------------------------------------------------------------ */

const MenuActive = (() => {

  const SELECTOR_LINKS = '.menu__item a';

  function init() {
    const currentPath = window.location.pathname;

    document.querySelectorAll(SELECTOR_LINKS).forEach(link => {
      const href = link.getAttribute('href');
      if (href && currentPath.startsWith(href)) {
        link.classList.add('menu-list__link--active');
      }
    });
  }

  return { init };

})();


/* ------------------------------------------------------------------------------------------------------------

scroll 

------------------------------------------------------------------------------------------------------------ */

const ScrollManager = (() => {

  let lastScroll = 0;

  function init() {
    update(); // état initial
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function onScroll() {
    window.requestAnimationFrame(update);
  }

  function update() {
    const y = window.scrollY;
    if (y > 10 && lastScroll <= 10) {
      document.body.classList.add("scroll");
    } else if (y <= 10 && lastScroll > 10) {
      document.body.classList.remove("scroll");
    }
    lastScroll = y;
  }

  return { init };

})();



/* ------------------------------------------------------------------------------------------------------------

INIT

------------------------------------------------------------------------------------------------------------ */

document.addEventListener('DOMContentLoaded', () => {
  RTEManager.init();
  MenuActive.init();
  ScrollManager.init();
});
